module.exports = __webpack_public_path__ + "media/images/spree/frontend/favicon-6b260131102606e89fd5d8df7db7ed95.ico";